import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArtworkCard } from '../components/ArtworkCard';
const artworks = [{
  id: 1,
  artist: 'Seren Oleska',
  title: 'Silence in White',
  medium: 'Oil on canvas',
  dimensions: '120 × 90 cm',
  price: '£2,400',
  imageUrl: 'https://images.unsplash.com/photo-1541963463532-d68292c34b19?auto=format&fit=crop&q=80&w=1000',
  aspectRatio: 'portrait' as const
}, {
  id: 2,
  artist: 'Dimitri Vael',
  title: 'Echoes of Structure',
  medium: 'Mixed media',
  dimensions: '80 × 80 cm',
  price: '£1,200',
  imageUrl: 'https://images.unsplash.com/photo-1507643179173-442f8552932c?auto=format&fit=crop&q=80&w=1000',
  aspectRatio: 'square' as const
}, {
  id: 3,
  artist: 'Anais Kove',
  title: 'Transient Forms',
  medium: 'Acrylic on linen',
  dimensions: '150 × 100 cm',
  price: '£3,200',
  imageUrl: 'https://images.unsplash.com/photo-1549887534-1541e9326642?auto=format&fit=crop&q=80&w=1000',
  aspectRatio: 'portrait' as const
}, {
  id: 4,
  artist: 'Thora Lind',
  title: 'Northern Light Study',
  medium: 'Charcoal and graphite',
  dimensions: '60 × 40 cm',
  price: '£800',
  imageUrl: 'https://images.unsplash.com/photo-1515405295579-ba7b454989d3?auto=format&fit=crop&q=80&w=1000',
  aspectRatio: 'portrait' as const
}, {
  id: 5,
  artist: 'Kasper Rhys',
  title: 'Industrial Decay II',
  medium: 'Oil and rust on steel',
  dimensions: '100 × 120 cm',
  price: '£2,800',
  imageUrl: 'https://images.unsplash.com/photo-1547891654-e66ed7ebb968?auto=format&fit=crop&q=80&w=1000',
  aspectRatio: 'landscape' as const
}, {
  id: 6,
  artist: 'Elara Moss',
  title: 'Botanical Abstraction',
  medium: 'Ink on paper',
  dimensions: '70 × 50 cm',
  price: '£950',
  imageUrl: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?auto=format&fit=crop&q=80&w=1000',
  aspectRatio: 'portrait' as const
}];
export function GalleryPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-25">
      <Header data-id="element-26" />

      <main className="flex-grow" data-id="element-27">
        {/* Hero Section */}
        <section className="pt-24 pb-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-28">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-29">
            <div className="md:col-span-8" data-id="element-30">
              <h1 className="text-6xl md:text-8xl font-light tracking-tight leading-tight mb-8" data-id="element-31">
                Young Artists <br data-id="element-32" />
                <span className="italic" data-id="element-33">2026</span>
              </h1>
            </div>
            <div className="md:col-span-4 flex flex-col justify-end pb-4" data-id="element-34">
              <div className="border-l border-black pl-6 space-y-4" data-id="element-35">
                <p className="text-xl font-serif italic" data-id="element-36">March 12 — April 24</p>
                <p className="text-gray-600 leading-relaxed max-w-xs" data-id="element-37">
                  A curated selection of emerging talent exploring the
                  boundaries of contemporary minimalism and structure.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Artworks Grid */}
        <section className="py-12 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-38">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-24" data-id="element-39">
            {artworks.map((artwork, index) => <div key={artwork.id} className={`${index % 2 !== 0 ? 'md:mt-16' : ''}`} data-id="element-40">
                <ArtworkCard {...artwork} data-id="element-41" />
              </div>)}
          </div>
        </section>

        {/* About Section */}
        <section className="py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-42">
          <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-43">
            <h2 className="text-4xl italic font-serif" data-id="element-44">The Exhibition</h2>
            <p className="text-xl leading-relaxed text-gray-800" data-id="element-45">
              Cosmiclevel presents six distinct voices defining the next
              generation of contemporary art. Through varied mediums and
              perspectives, these works challenge our perception of space, form,
              and materiality in an increasingly digital world.
            </p>
          </div>
        </section>

        {/* Visit Section */}
        <section className="py-24 px-6 md:px-12 border-t border-black mx-6 md:mx-12" data-id="element-46">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-47">
            <div data-id="element-48">
              <h2 className="text-4xl mb-8" data-id="element-49">Visit</h2>
              <div className="space-y-2 text-lg" data-id="element-50">
                <p className="font-medium" data-id="element-51">Cosmiclevel</p>
                <p data-id="element-52">74 W End Ln</p>
                <p data-id="element-53">London NW6 2LX</p>
              </div>
            </div>
            <div className="md:text-right flex flex-col md:items-end justify-between" data-id="element-54">
              <div className="space-y-2 text-lg" data-id="element-55">
                <p data-id="element-56">Tuesday — Saturday</p>
                <p data-id="element-57">11:00 — 18:00</p>
              </div>
              <p className="mt-8 text-gray-500 italic" data-id="element-58">Admission is free</p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-59" />
    </div>;
}